import type { CSSProperties, FC } from 'react';
import './CroopLoader.css';

interface CroopLoaderProps {
  size?: number | string;
  variant?: 'light' | 'dark';
  duration?: number;
  paused?: boolean;
  label?: string;
  className?: string;
}

const CroopLoader: FC<CroopLoaderProps> = ({
  size = 48,
  variant = 'light',
  duration = 4,
  paused = false,
  label = 'Croop',
  className = ''
}) => {
  const isDark = variant === 'dark';
  const style = {
    '--croop-loader-duration': `${Math.max(0.5, duration)}s`
  } as CSSProperties;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      className={`croop-loader ${className}`.trim()}
      data-paused={paused ? 'true' : 'false'}
      style={style}
      role={label ? 'img' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <path
        d="M334.2500,391.5330 A156.5,156.5 0 1 1 334.2500,120.4670"
        fill="none"
        stroke={isDark ? '#B48AE0' : '#7433A0'}
        strokeWidth="99"
        strokeLinecap="round"
      />
      <g className="croop-loader__arc">
        <path
          d="M354.4886,134.3767 A156.5,156.5 0 0 1 354.4886,377.6233"
          fill="none"
          stroke={isDark ? '#A5DDD4' : '#66C0B3'}
          opacity={isDark ? 0.85 : 0.76}
          strokeWidth="99"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default CroopLoader;
